var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:5.78px;}.cls-2{fill:currentColor;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 108.89,
    cy: 109.11,
    r: 76.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 108.89,
    cy: 109.11,
    r: 43.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 108.89,
    cy: 109.11,
    r: 17.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.89,
    y1: 33.86,
    x2: 108.89,
    y2: 184.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 33.64,
    y1: 109.11,
    x2: 184.14,
    y2: 109.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 81.54,
    cy: 54.53,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 88.08,
    cy: 133.71,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 154.82,
    cy: 72.86,
    r: 3.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadar);
export default __webpack_public_path__ + "static/media/RADAR.dcc3b4611e500ed8725dffd5b8274821.svg";
export { ForwardRef as ReactComponent };